import { HttpMapper } from './http-mapper';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../environment';
import { HttpProvider } from '../http/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggerEvent, LoggerProvider } from '../logger/logger';

@Injectable()
export class AccountProvider {
  tokenIsEncrypted: boolean;

  constructor(
    public http: HttpMapper,
    private httpProvider: HttpProvider,
    private httpReqProvider : HttpClient
  ) {}

  customerLink(data: any): Observable<any> {
    return this.http.post(APP_CONFIG.API_URL + 'api/Account/BeginCustomerEnrollment', data);
  }

  checkIfDeepLinkPhoneValid(token: any, userLogin: any, isEncrypted=true) : Observable<any>  {
    if (typeof this.tokenIsEncrypted !== 'undefined') isEncrypted = this.tokenIsEncrypted;
    return this.http.put(APP_CONFIG.API_URL + 'api/Account/Verification/Token/' + token + '/IsPhoneValid?isEncrypted=' + isEncrypted,{ sessionId: userLogin.SessionId});
  }

  completeLinkWithPassword(token: any, userLogin: any, isEncrypted = true, oldPassword?, isDeeplinkingRegistration: boolean = false, mfaDeviceToken?): Observable<any> {
    if (typeof this.tokenIsEncrypted !== 'undefined') isEncrypted = this.tokenIsEncrypted;
    if (oldPassword)
      return this.http.put(APP_CONFIG.API_URL + 'api/Account/Verification/Token/' + token + '/User?isEncrypted=' + isEncrypted, { oldPassword: userLogin.Password, sessionId: userLogin.SessionId });
    else{
      let reqBody = {
        password: userLogin.Password,
        sessionId: userLogin.SessionId
      }
      if(isDeeplinkingRegistration && mfaDeviceToken){
        reqBody['DeviceId'] = LoggerProvider.uuid;
        reqBody['DeviceSimCard'] = mfaDeviceToken;
      }
      return this.http.put(APP_CONFIG.API_URL + 'api/Account/Verification/Token/' + token + '/User?isEncrypted=' + isEncrypted, reqBody);
    }
  }

  getFields(): Observable<any> {
    return this.http.get(APP_CONFIG.API_URL + 'api/Account/Verification/MandatoryFields');
  }

  userRegistered(loginName: string, resourceType: number, captchaSession): Promise<any> {
    if (loginName)
      loginName = encodeURIComponent(loginName.trim());
    return this.httpProvider.get(APP_CONFIG.API_URL + 'api/Account/User/' + loginName + '/ResourceType/' + resourceType + '/IsRegistered', {}, null, {
      captchaSession,
    });
  }

  forgotPassRequest( loginName: string, captchaSession): Promise<any> {
    let param = {
      'LoginName': loginName
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/account/ForgotPassword/V2',param, null, {
      captchaSession
    });
  }

  forgotPass( loginName: string = "", password: string = null, securityCode: string = null, referenceValue: string = null): Observable<any> {
    let param = {
      'LoginName': loginName,
      'Password': password,
      'securityCode': securityCode,
      'referenceValue': referenceValue
    }
    return this.http.post(APP_CONFIG.API_URL + 'api/account/ForgotPassword/V2',param);
  }

  deleteAccount(): Promise<any> {
    return this.httpProvider.delete(APP_CONFIG.API_URL + 'api/Account/Delete', {});
  }

  updatePass(password: string = null, securityCode: string = null, referenceValue: string = null): Observable<any> {
    let param = {
      'Password': password,
      'securityCode': securityCode,
      'referenceValue': referenceValue
    }
    return this.http.post(APP_CONFIG.API_URL + 'api/account/ForgotPassword/V2/Update',param);
  }

  forgotPassBirthDate(birthDate: string, referenceValue: string) {
    const param = {
      'BirthDate': birthDate,
      'referenceValue': referenceValue
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/account/ForgotPassword/VerifyBirthdate', param);
  }

  availableDeliveryTypes(loginName: string, captchaSession): Promise<any> {
    let param = {
      'LoginName': loginName,
    }
    return this.httpProvider.post(APP_CONFIG.API_URL + 'api/Account/ForgotPassword/DeliveryTypes', param, null, {
      captchaSession
    });
  }

  async checkTokenValidation(token:string, isEncrypted=true, referralAffiliate = null, isObserveResponse: boolean = false, advertisingPartnerName = null): Promise<any>{
     try {
      this.tokenIsEncrypted = isEncrypted;
      let url =  APP_CONFIG.API_URL+`api/Account/Verification/Token/IsValid`;
      if(isObserveResponse){
        let reqBody = {
          Token: token,
          IsEncrypted: isEncrypted,
          AdvertisingPartnerName: advertisingPartnerName
        }
        if (referralAffiliate) reqBody['ReferralAffiliate'] = referralAffiliate;
        let headers = await this.httpProvider.getNewHeader(url) || '';
        const result = await this.httpReqProvider.post(url, reqBody , { observe:'response', headers: new HttpHeaders(headers) }).toPromise();
        return result;
      } else {
        const result = await this.httpProvider.post(url, {
          Token: token,
          IsEncrypted: isEncrypted,
          ReferralAffiliate: referralAffiliate
        });
        return result;
      }
     } catch (ex) {
      if (ex.status === 404)
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Fallback in token validation');
      else {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to check token validation');
        throw ex;
      }
     }

     LoggerProvider.info(this, 'Fallback in token validation');
     return await this.httpProvider.get(APP_CONFIG.API_URL+`api/Account/Verification/Token/${token}/IsValid?isEncrypted=${isEncrypted}`);
  }

  // createUserWithToken(token:string,password:string,isEncrypted=true):Promise<any>{
  //   return this.http.put(APP_CONFIG.API_URL + 'api/Account/Verification/Token/' + token + '/User?isEncrypted=' + isEncrypted,{password: password}).toPromise();
  // }
}



// WEBPACK FOOTER //
// ./src/providers/myria/account-provider.ts